<template>
    <v-card class="rounded-4"> 
        <v-toolbar flat height="45px">  
            <b>{{ formattedTransDate }} Overtime Requests</b>
            <v-spacer></v-spacer>  
            <v-btn icon @click.native="closeDialog()" >
                <v-icon>close</v-icon>
            </v-btn>                      
        </v-toolbar>
        <v-card-text>
            <v-text-field v-model="search" :class="isMobile?'wp-90 mt-0 ml-20':'wp-50 ml-20 mt-0'" append-icon="search" label="Search name" single-line hide-details clearable></v-text-field>  
            <v-data-table
                :class="isMobile?'mt-n50':''"
                :headers="isMobile ? [] : headers"
                :items="overtime_filtered"
                :loading="loading"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="paginationSync"
                :hide-actions="overtime_filtered.length<6"
            >
                <template v-slot:items="props">

                    <!-- mobile view -->
                    <tr v-if="isMobile">
                        <td :colspan="headers.length" class="pa-1">
                            <v-card class="elevation-1" @click="viewOvertimeDetails(props.item)">
                                <v-toolbar flat height="42">
                                    <v-chip class="user-chip-container">
                                        <v-avatar>
                                            <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                        </v-avatar>
                                        {{props.item.firstName}} {{props.item.lastName}}
                                    </v-chip>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                                <v-layout row wrap align-center class="section-layout">
                                    <v-flex xs12 class="text-xs-left mt-1 mb-1">
                                        <v-layout row wrap>
                                            <v-flex xs12 sm4>
                                                <div class="caption grey--text">Start/End</div>
                                                <div>{{props.item.startTime|moment('hh:mm a')}} - {{props.item.endTime|moment('hh:mm a')}}</div>
                                            </v-flex>
                                            <v-flex xs12 sm4>
                                                <div class="caption grey--text">Charging Type</div>
                                                <span v-if="props.item.offsetOrPay==1">Time Off in Lieu (TOIL)</span>
                                                <span v-else>Payroll (Paid Overtime)</span>
                                            </v-flex>
                                            <v-flex xs12 sm4>
                                                <div class="caption grey--text">Status</div>
                                                <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </td>
                    </tr>

                    <!-- desktop view -->
                    <tr v-else @click="viewOvertimeDetails(props.item)" title="Click to view details" class="clickable">
                        <td>
                            <v-chip class="user-chip-container">
                                <v-avatar>
                                    <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                </v-avatar>
                                {{props.item.firstName}} {{props.item.lastName}}
                            </v-chip>
                        </td>
                        <td>{{props.item.startTime|moment('hh:mm a')}} - {{props.item.endTime|moment('hh:mm a')}}</td>
                        <td>
                            <span v-if="props.item.offsetOrPay==1">Time Off in Lieu (TOIL)</span>
                            <span v-else>Payroll (Paid Overtime)</span>
                        </td>
                        <td>
                            <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                        </td>
                    </tr>

                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>
<script>

import overtimeApi from '@/api/overtime'
import commonfn from '@/common/functions'   //for refactor
import { getSort, getSearchKeyword, getRowsPerPage, updateRowsPerPage, updateSort, updateSearchKeyword } from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'
import awsS3Helper from '@/helpers/aws-s3'

export default {
    data () {
        const routeName = `${this.$route.name}-ViewAllOvertimeByDate`
        const savedSort = getSort(routeName)
        
        return {
            awsS3Helper,
            commonfn,
            rowsPerPageItems,
            error: false,
            errorMessage: null,
            loading: false,
            disabled: false,
            search: getSearchKeyword(routeName),
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            headers: [
                {text: 'Employee', align: 'left', value: 'firstName', width:'30%', sortable:true},
                {text: 'Start/End',align: 'left',value: 'startTime', width:'25%',sortable:true}, 
                {text: 'Charging Type',align: 'left',value: 'offsetOrPay', width:'25%',sortable:true},
                {text: 'Status', align: 'left', value: 'status', width: '20%', sortable:true},
            ],
            overtime: [],
            selectedTransDate: null
        }   
    },
    methods: {
        viewOvertimeDetails(data) {
            this.$router.push(`overtime/details/${data.overtimeId}`)
        },
        async getOvertime(transDate) {
            try {
                this.overtime = []
                this.loading = true
                this.selectedTransDate = transDate
                const response = await overtimeApi.getByTransDateByTeam(transDate)
                if (response && response.status == 200) {
                    this.overtime = response.data.items
                }
                 this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        closeDialog() {
            this.$emit('update:dialogOvertimeList', false)
        },
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(`${this.$route.name}-ViewAllOvertimeByDate`, newVal);
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(`${this.$route.name}-ViewAllOvertimeByDate`, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(`${this.$route.name}-ViewAllOvertimeByDate`, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            updateSearchKeyword(`${this.$route.name}-ViewAllOvertimeByDate`, newVal)
        }
    },
    computed: {
        overtime_filtered() {
            var temp = this.overtime

            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    const searchLowered = this.search.toLowerCase()
                    const firstNameMatch = item.firstName.toLowerCase().includes(searchLowered)
                    const lastNameMatch = item.lastName.toLowerCase().includes(searchLowered)

                    return firstNameMatch || lastNameMatch
                })
            }
            return temp
        },
        formattedTransDate() {
            return this.$moment(this.selectedTransDate).format('MMM D, YYYY')
        }
    }
}
</script>
<style scoped>
.section-layout {
    padding:0px 23px 0px 23px;
}

/* somehow unable to align the table to the top on mobile view, this is temporary fix */
.mt-n50 {
    margin-top:-50px;
}
</style>